<div class="inspection-completion-success-popup" style="height: 100%">
  <div class="inspection-completion-success-popup__success-icon">
    <ion-img [src]="'/assets/common/success.svg'"></ion-img>
  </div>
  <div class="inspection-completion-success-popup__heading">
    {{ heading }}
  </div>
  <div class="inspection-completion-success-popup__result-quantities">
    <div *ngFor="let item of resultQuantities">
      <span class="label">{{ item.label }}</span> : <span class="value">{{ item.value }}</span>
    </div>
  </div>
  <div class="inspection-completion-success-popup__navigation-message">
    {{ navigationMessage }}
  </div>
</div>
